import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SplashScreenService } from '../../services/splash-screen/splash-screen.service';

@Component({
  selector: 'app-splash-screen',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './splash-screen.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './splash-screen.component.scss',
})
export class SplashScreenComponent {
  readonly splashScreenService = inject(SplashScreenService);
  logoFailed = false;

  onLogoError(event: Event): void {
    const img = event.target as HTMLImageElement;
    if (img.dataset['fallbackApplied'] === 'true') {
      this.logoFailed = true;
      return;
    }

    img.dataset['fallbackApplied'] = 'true';
    img.src = '/assets/icons/splash-logo.png';
  }
}
